class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
          const cartDrawerItems = this.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.updateCartUpsellToggleState();
      cartDrawerItems.updateCartUpsellVisibility();
    }

    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* PM GoKwik checkout bridge (22 Oct 2026): routes Check out and Buy it now to GoKwik, falls back to Shopify checkout if GoKwik is not ready */
(function () {
  if (window.__pmGk) return;
  window.__pmGk = 1;
  window.merchantInfo = { mid: '2ljp4imn5zujgw', environment: 'production', type: 'merchantInfo', storeId: '79038841047', fbpixel: '1404906333890627', snapchatPixels: '' };
  window.gaTag = { ga4: 'G-2JLS0R9QFD' };
  window.productFormSelector = '';
  window.templateName = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType) || '';
  var s = document.createElement('script');
  s.src = 'https://pdp.gokwik.co/merchant-integration/build/merchant.integration.js?v4';
  s.defer = true;
  document.head.appendChild(s);
  var proxy = document.createElement('div');
  proxy.className = 'gokwik-checkout';
  proxy.style.display = 'none';
  proxy.innerHTML = '<button type="button" class="button"><span class="btn-text"><span>Checkout</span></span><div style="display:none" class="addloadr" id="btn-loader"><div class="cir-loader">Loading..</div></div></button>';
  function pbtn() { if (!proxy.parentNode && document.body) document.body.appendChild(proxy); return proxy.querySelector('button'); }
  function ready() { return typeof window.onCheckoutClick === 'function'; }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function go() {
    return getCart().then(function (c) {
      window.cart = c;
      if (!c.item_count) { location.href = '/cart'; return; }
      window.onCheckoutClick(pbtn());
    });
  }
  function nativeFallback() { try { location.href = '/checkout'; } catch (e) {} }
  document.addEventListener('click', function (e) {
    var t = (e.composedPath && e.composedPath()[0]) || e.target;
    if (!t || !t.closest) return;
    var buy = t.closest('.shopify-payment-button__button, .shopify-payment-button, shopify-buy-it-now-button');
    var chk = t.closest('#CartDrawer-Checkout, button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"], .cart__checkout-button');
    if (!buy && !chk) return;
    if (!ready()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (chk) { go().catch(nativeFallback); return; }
    var form = (buy.closest && buy.closest('form')) || document.querySelector('form[action*="/cart/add"]');
    var addBtn = form && form.querySelector('button[name="add"], button[type="submit"]:not(.shopify-payment-button__button)');
    if (!addBtn) { go().catch(nativeFallback); return; }
    getCart().then(function (c0) {
      var before = c0.item_count;
      addBtn.click();
      var tries = 0;
      (function poll() {
        getCart().then(function (c) {
          if (c.item_count !== before || tries > 12) { go().catch(nativeFallback); }
          else { tries++; setTimeout(poll, 400); }
        });
      })();
    }).catch(nativeFallback);
  }, true);
})();
